import { useParams } from 'next/navigation';
import { useEffect, useState } from 'react';

const getHash = () =>
  typeof window !== 'undefined' ? window.location.hash.replace(/^#/, '') : '';

export const useHash = () => {
  const params = useParams();
  const [hash, setHash] = useState<string>('');

  useEffect(() => {
    setHash(getHash());
  }, [params]);

  useEffect(() => {
    const handleHashChange = () => setHash(getHash());
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return hash;
};
